import { App } from 'vue'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AllPermissions } from '@/Network/Types/Responses/AuthorizationResponses'
import {
  Authorization,
  AuthorizationPermissionCheck,
  AuthorizationPermissions,
  Authorizations
} from '@/types/authorization'

export type CanFunction = (
  permissionKey: AllPermissions,
  resourceType: string,
  resourceId?: string | number | null
) => boolean

export type BulkCheckFunction = (authorizations: Authorizations) => boolean

export type ProvideAuthorization = {
  bulkCheck: BulkCheckFunction
}

export type OptionsAuthorization = unknown

export type CanAnyFunction = (permissionKey: AllPermissions, resourceType: string) => boolean

export type CanAccessRouteFunction = (authorizations: Authorizations) => boolean

export default {
  install(app: App) {
    app.config.globalProperties.$check = (
      permissionKey: AllPermissions,
      resourceType: string,
      resourceId: string | number | null = null
    ): boolean => {
      const permissionsStore = usePermissionsStore()

      const checkObject: AuthorizationPermissionCheck = {
        permission: permissionKey as unknown as AuthorizationPermissions,
        resource: {
          objectType: resourceType as any,
          objectId: Number(resourceId) ? Number(resourceId) : 0
        }
      }

      return permissionsStore.check(checkObject)
    }

    app.config.globalProperties.$checkAnyResources = (
      permissionKey: AllPermissions,
      resourceType: string
    ): boolean => {
      const permissionsStore = usePermissionsStore()

      const checkObject: Authorization = {
        permission: permissionKey as unknown as AuthorizationPermissions,
        resourceType: resourceType as any
      }

      return permissionsStore.checkAnyRessources(checkObject)
    }

    app.config.globalProperties.$bulkCheck = (
      authorizations: AuthorizationPermissionCheck[]
    ): boolean => {
      const permissionsStore = usePermissionsStore()

      if (!authorizations || authorizations.length === 0) {
        return true
      }

      return permissionsStore.bulkCheck(authorizations)
    }

    app.provide('authorization', {
      bulkCheck: app.config.globalProperties.$bulkCheck as BulkCheckFunction
    })
  }
}
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $check: CanFunction
    $checkAnyResources: CanAnyFunction
    $checkAccessRoute: CanAccessRouteFunction
  }
}
